export function setInfo2(info, isM60_2004) {
	return {
		style: {
			flexDirection: "column"
		},
		children: [
			{
				children: [
					{
						style: {
              width: "25mm",
              flex: "none"
            },
						width: null,
						text: `款号`,
						propsName: 'materialCode'
					},
					{
						style: {
							width: "12mm",
							flex: "none"
						},
						width: null,
						text: `实际进仓数`,
						propsName: 'warehousNumber'
					},
					{
						style: {
							width: "12mm",
							flex: "none"
						},
						width: null,
						text: `零售价/FOB价`,
						propsName: 'price'
					},
					{
						style: {
							width: "8mm",
							flex: "none"
						},
						width: null,
						text: `需调数量`,
						propsName: 'taxNumber'
					},
					{
						style: {
              width: "15mm",
              flex: "none"
            },
						width: null,
						text: `合同不含税单价`,
						propsName: 'contractPrice'
					},
					{
						style: {
							width: "15mm",
							flex: "none"
						},
						width: null,
						text: `SAP不含税单价`,
						propsName: 'sapPrice'
					},
					{
						style: {
							width: "18mm",
							flex: "none"
						},
						width: null,
						text: `需调不含税差价`,
						propsName: 'differencePrice'
					},
					{
						style: {
              width: "15mm",
              flex: "none"
            },
						width: null,
						text: `需调含税金额`,
						propsName: 'includingTaxPrice',
						hide: isM60_2004
					},
					{
						style: {
							width: "20mm",
							flex: "none"
						},
						width: null,
						text: `需调不含税金额`,
						propsName: 'noTaxPrice'
					},
					{
						style: {
							width: "20mm",
							flex: "none"
						},
						width: null,
						text: `需调税额`,
						propsName: 'taxPrice',
						hide: isM60_2004
					},
					{
						style: {
							width: "18mm",
							flex: "none"
						},
						width: null,
						text: `采购订单号`,
						propsName: 'sapOrderNo'
					},
					{
						style: {
							width: "15mm",
							flex: "none"
						},
						width: null,
						text: `发票凭证单号`
					},
					{
						style: {
							width: "15mm",
							flex: "none"
						},
						width: null,
						text: `财务SAP号`
					},
					{
						// style: {
						// 	width: "40mm",
						// 	flex: "none"
						// },
						width: null,
						text: `备注`,
						propsName: 'remark'
					},
				]
			}
		]
	}
}


export function copySetInfo2(isM60_2004) {
	return {
		style: {
			height: "8mm",
			flex: "none"
		},
		children: [
			{
				style: {
					width: "25mm",
					flex: "none"
				},
				width: null,
				text: ''
			},
			{
				style: {
					width: "12mm",
					flex: "none"
				},
				width: null,
				text: ``
			},
			{
				style: {
					width: "12mm",
					flex: "none"
				},
				width: null,
				text: ``
			},
			{
				style: {
					width: "8mm",
					flex: "none"
				},
				width: null,
				text: ``
			},
			{
				style: {
					width: "15mm",
					flex: "none"
				},
				width: null,
				text: null
			},
			{
				style: {
					width: "15mm",
					flex: "none"
				},
				width: null,
				text: null
			},
			{
				style: {
					width: "18mm",
					flex: "none"
				},
				width: null,
				text: null
			},
			{
				style: {
					width: "15mm",
					flex: "none"
				},
				width: null,
				text: null,
				hide: isM60_2004
			},
			{
				style: {
					width: "20mm",
					flex: "none"
				},
				width: null,
				text: null
			},
			{
				style: {
					width: "20mm",
					flex: "none"
				},
				width: null,
				text: null,
				hide: isM60_2004
			},
			{
				style: {
					width: "18mm",
					flex: "none"
				},
				width: null,
				text: null
			},
			{
				style: {
					width: "15mm",
					flex: "none"
				},
				width: null,
				text: null
			},
			{
				style: {
					width: "15mm",
					flex: "none"
				},
				width: null,
				text: null
			},
			{
				// style: {
				// 	width: "50mm",
				// 	flex: "none"
				// },
				width: null,
				text: null
			},
		]
	}
}
